<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-08-27 20:04:52
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-31 11:28:05
 * @FilePath: /b2c_public_components/src/zz-report/src/process.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    v-if="
      dataInfo.checkProcess ||
      (dataInfo.checkVideo && dataInfo.checkVideo.length && dataInfo.checkVideo[0].videoUrl)
    "
    class="new-test-process"
  >
    <p class="new-test-process-title">真的官方验 · 一物一验</p>
    <p class="new-test-process-subtitle">
      <span>大部分人一开始都不放心二手，所以我们选择一物一验</span>
    </p>

    <quality-vr v-if="!isWeChat" :dataInfo="dataInfo"></quality-vr>

    <div
      v-if="dataInfo.checkVideo && dataInfo.checkVideo.length && dataInfo.checkVideo[0].videoUrl"
      class="new-test-process-video"
      @click="playVideo(dataInfo.checkVideo[0].videoUrl)"
    >
      <img v-lazy="$setPicSize(dataInfo.checkVideo[0].imageUrl, 375)" />
    </div>
    <div v-if="dataInfo.checkProcess" class="new-test-process-img" @click="processClick()">
      <img v-lazy="$setPicSize(dataInfo.checkProcess, 686)" />
    </div>
  </div>
</template>

<script>
  import { playVideoBySystem, skipToUrl, isPlatform } from '../../utils/native'
  import QualityVr from './quality-vr'
  import { setPicSize } from '@zz-common/zz-utils'
  export default {
    components: {
      QualityVr,
    },
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
    },
    data() {
      return {
        isWeChat: false,
      }
    },
    mounted() {
      this.isWeChat = isPlatform('wa')
    },
    methods: {
      playVideo(url) {
        playVideoBySystem({ url })
      },
      processClick() {
        skipToUrl({
          targetUrl: `//m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/61c1a9c4fac5080060be599d/index.html?needNewWebview=1`,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .new-test-process {
    padding-top: 68px;
    &-title {
      margin-bottom: 24px;
      font-size: 36px;
      line-height: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #111111;
      // letter-spacing: 4px;
    }
    &-subtitle span {
      display: inline-block;
      position: relative;
      margin-bottom: 24px;
      font-size: 24px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #999999;
    }

    .new-test-process-video,
    .new-test-process-img {
      margin-top: 12px;
    }
    .new-test-process-img {
      width: 100%;
      object-fit: contain;
    }
    &-img {
      // height: 165px;
      img {
        width: 100%;
      }
    }
    &-video {
      margin-bottom: 8px;
      img {
        width: 100%;
      }
    }
  }
</style>
